import HorizontalIndicator from './HorizontalIndicator';

export default HorizontalIndicator;
